export function menuToggle(
  menuToggleEl,
  menuToggleButtonEl,
) {
  if (
    $(menuToggleEl).length &&
    $(menuToggleButtonEl).length
  ) {
    $(menuToggleButtonEl)
      .on("click", function () {
        if ($(this).hasClass('is-active')) {
          $(menuToggleButtonEl).removeClass("is-active");
          $(menuToggleEl).removeClass("is-active");
          $(this).removeClass("is-active");
          $(this).next(menuToggleEl).removeClass("is-active");
        } else {
          $(menuToggleButtonEl).removeClass("is-active");
          $(menuToggleEl).removeClass("is-active");
          $(this).addClass("is-active");
          $(this).next(menuToggleEl).addClass("is-active");
        }
      });
  }
}
